import { type NextProfitsResponse, nextProfitsResponseSchema } from 'investments/common/definitions'

import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { type UseQueryRequestOptions, useQueryRequest } from '~/ui/hooks/utils/service/use-query-request'

async function fetchNextProfits({ accountId }: { accountId: string }) {
  const { data } = await httpClientBanking({
    url: `/investments/accounts/${accountId}/next_profits`,
    method: 'GET'
  })

  return nextProfitsResponseSchema.parse(data)
}

export function getUseFetchNextProfitsKey(accountId: string) {
  return ['useFetchNextProfits', accountId] as const
}

export function useFetchNextProfits({
  accountId,
  options
}: {
  accountId: string
  options?: UseQueryRequestOptions<NextProfitsResponse, unknown, true>
}) {
  return useQueryRequest<NextProfitsResponse, unknown, true>(
    getUseFetchNextProfitsKey(accountId),
    () => fetchNextProfits({ accountId }),
    {
      suspense: false,
      retry: false,
      ...options
    }
  )
}
